import { createUseStyles } from "react-jss";
import { ITheme } from "../../../../constants/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  title: {
    margin: `0 ${theme.spacing.space16}px`,
    "&.topGame": {
      display: "flex",
      gap: 5,
    },
  },
  content: {
    display: "flex",
    gap: theme.spacing.space12,
    overflowX: "auto",
    overflowY: "hidden",
    whiteSpace: "nowrap",
    scrollBehavior: "smooth",
    padding: `0px ${theme.spacing.space16}px`,
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
  gameImg: {
    minWidth: 104,
    borderRadius: theme.radius.small,
  },
}));
